import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const appendCurrentQueryParams = (baseUrl: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  return `${baseUrl}?${queryParams.toString()}`;
};

export function withFbq<T extends (...args: any[]) => any>(
  event: string,
  params?: Record<string, any>,
  fn?: T
): (...args: Parameters<T>) => void {
  return (...args: Parameters<T>) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
    if (fn) {
      fn(...args);
    }
  };
}

export function dispatchLead<T extends (...args: any[]) => any>(
  fn?: T
): (...args: Parameters<T>) => void {
  return (...args: Parameters<T>) => {
    if (
      typeof window !== "undefined" &&
      typeof window.MetaClient?.sendLead === "function"
    ) {
      window.MetaClient.sendLead();
    }
    if (fn) {
      fn(...args);
    }
  };
}
